import React from "react";

interface WithStopPropagationProps {
  children: React.ReactNode;
  className?: string;
}

function stopPropagation(e: React.MouseEvent<HTMLElement>) {
  e.stopPropagation();
}

export default function WithStopPropagation(props: WithStopPropagationProps) {
  return (
    <div className={props.className} onClick={stopPropagation}>
      {props.children}
    </div>
  );
}
